import script from "./EmptyList.vue?vue&type=script&setup=true&lang=js"
export * from "./EmptyList.vue?vue&type=script&setup=true&lang=js"

import "./EmptyList.vue?vue&type=style&index=0&id=b45b256a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b45b256a"]])

export default __exports__